class LoadButtonComponent extends HTMLElement {

  constructor() {
    super();
    document.addEventListener('project-loaded', (event) => this.onUpdate(event.detail), true)
    document.addEventListener('update-load-button', async (event) => this.onUpdate(event.detail), true)
  }

  onUpdate(footingDesign) {
    let str = `<strong>Loads</strong>`
    str += `<div>Dead Load (<em>D</em>) = ${footingDesign.load.columnDeadLoad} kips</div>`
    str += `<div>Live Load (<em>L</em>) = ${footingDesign.load.columnLiveLoad} kips</div>`
    str += `<div>Floor Load = ${footingDesign.load.floorLoad} lb/ft<sup>2</sup></div>`
    str += `<div>Floor Slab = ${footingDesign.load.floorSlabThickness} in @ ${footingDesign.load.floorSlabDensity} lb/ft<sup>3</sup></div>`
    str += `<div>Fill = ${footingDesign.load.fillDepth} in @ ${footingDesign.load.fillDensity} lb/ft<sup>3</sup></div>`
    
    document.getElementById('load-button').innerHTML = str
  }

  onFootingTypeChange(footingConditions) {
    this.configure(footingConditions)
  }

  connectedCallback() {
    this.innerHTML = String.raw`
      <div class="card">
        <a href="#" data-bs-toggle="modal" data-bs-target="#modal-load-dialog" style="text-decoration: none;">
          <div class="panel-shadow text-center" style="padding:10px;" id="load-button">
          </div>
        </a>
      </div>
    `
  }
}

customElements.define('load-button-component', LoadButtonComponent);